import { Component, Input, OnInit } from '@angular/core';
import { BookingDoctor } from 'src/app/entities/booking-doctor.entity/booking-doctor';
import { Language } from 'src/app/services/localization.service/localization.service';

@Component({
  selector: 'app-doctors-list',
  templateUrl: './doctors-list.component.html',
  styleUrls: ['./doctors-list.component.css']
})
export class DoctorsListComponent implements OnInit {
  @Input() doctors: Array<BookingDoctor> = new Array();
  @Input() pageRequest: any
  @Input() currentPage: number = 0;
  @Input() perPage: number = 10;
  @Input() language: Language = 'fr';
  constructor() { }

  ngOnInit(): void {

  }

  getProfileLink(cabientOrganization: BookingDoctor): string {
    
    return `https://siladoc.com/${this.language == "fr" ? '' : 'ar/'}medecins/${cabientOrganization.specialityRef}/${cabientOrganization.governmentSlug}/${cabientOrganization.citySlug}/${cabientOrganization.ref.toLowerCase()}`;
    // return `/${this.language == "fr" ? '' : 'ar/'}doctor/${cabientOrganization.id}`;}
  }}
